import { RECEIVE_PRODUCTS } from '../actions/productActions';
var initialState = {
  products: [],
  decimalPlaces: {}
};
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var _ref = arguments[1];
  var type = _ref.type,
    payload = _ref.payload;
  switch (type) {
    case RECEIVE_PRODUCTS:
      return handleReceiveProducts(state, payload);
    default:
      return state;
  }
}
function handleReceiveProducts(state, products) {
  var decimalPlaces = {};
  products.forEach(function (product) {
    decimalPlaces[product.Product] = product.DecimalPlaces;
  });
  return Object.assign({}, state, {
    products: products,
    decimalPlaces: decimalPlaces
  });
}